import { render, staticRenderFns } from "./InstantCampaignList.vue?vue&type=template&id=64704cd7&scoped=true"
import script from "./InstantCampaignList.vue?vue&type=script&lang=js"
export * from "./InstantCampaignList.vue?vue&type=script&lang=js"
import style0 from "./InstantCampaignList.vue?vue&type=style&index=0&id=64704cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64704cd7",
  null
  
)

export default component.exports